import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { SalesCommissionLineNamesDataGrid } from "src/components/views/erp/sales/masterData/salesCommissions/SalesCommissionLineNamesDataGrid.tsx";

export const Route = createFileRoute("/_authenticated/_shell/sales/salesCommissions/lineNames")({
	staticData: { title: i18n.t("commission_line_names"), legacyViewKey: "salesCommissionLineNamesView" },
	component: RouteComponent,
});

function RouteComponent() {
	return <SalesCommissionLineNamesDataGrid />;
}
